import 배경이미지 from "../assets/gameBg.png";

export class Background {
  x: number;
  y: number;
  width: number;
  height: number;
  image: HTMLImageElement;

  constructor(x: number, y: number, width: number, height: number) {
    this.x = x;
    this.y = y;
    this.width = width;
    this.height = height;

    this.image = new Image();
    this.image.src = 배경이미지;
  }

  draw(ctx: CanvasRenderingContext2D) {
    // ctx.fillStyle = "red";
    // ctx.fillRect(this.x, this.y, this.width, this.height);
    ctx.drawImage(this.image, this.x, this.y, this.width, this.height);
  }
}
